// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2diMN","col":"CardReaderDesc_col__2kHv4","label":"CardReaderDesc_label__1eU6Q"};